import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./HeroSlider.css";
import { useNavigate } from "react-router-dom";

const HeroSlider = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const router = useNavigate();

  const slides = [
    {
      image: "/slidders/lawpic1.png",
      title: "Premium Legal Services",
      subtitle:
        "Access trusted legal professionals anytime, anywhere with complete confidentiality.",
    },
    {
      image: "/slidders/lawpic2.png",
      title: "Justice Without Boundaries",
      subtitle:
        "Connect instantly with verified lawyers ready to guide and represent you.",
    },
  ];

  return (
    <section className="elite-shell">
      <Swiper
        modules={[Autoplay, EffectFade, Navigation, Pagination]}
        effect="fade"
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop={true}
        pagination={{ clickable: true }}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        className="elite-swiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="elite-slide">
              
              <div
                className="elite-blur-bg"
                style={{ backgroundImage: `url(${slide.image})` }}
              />

              <div className="elite-container">
                <div className="elite-image-wrapper">
                  <img
                    src={slide.image}
                    alt="Legal Visual"
                    className="elite-main-image"
                  />
                </div>

                <div className="elite-content">
                  <h1 className="elite-title">{slide.title}</h1>
                  <p
                    style={{ color: "white", fontWeight: "bolder" }}
                    className="elite-subtitle"
                  >
                    {slide.subtitle}
                  </p>
                  <button
                    onClick={() => router("/lawyers")}
                    className="elite-button"
                  >
                    Find a Lawyer
                  </button>
                </div>
              </div>

            </div>
          </SwiperSlide>
        ))}

        <div className="elite-nav">
          <button ref={prevRef} className="elite-prev">‹</button>
          <button ref={nextRef} className="elite-next">›</button>
        </div>
      </Swiper>
    </section>
  );
};

export default HeroSlider;